import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X } from 'lucide-react';
const NAMES = ['Mateo', 'Valentina', 'Benjamín', 'Sofía', 'Joaquín', 'Martina', 'Tomás', 'Camila', 'Santino', 'Catalina', 'Bautista', 'Luciana'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Bariloche', 'Neuquén', 'San Juan', 'Santa Fe'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const [timeAgo, setTimeAgo] = useState(1);
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 10) + 1;
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setTimeAgo(randomTime);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(triggerPopup, 5000);
    // Loop with random intervals between 15s and 25s
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-113">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 flex items-center gap-3 bg-trek-blackLight border border-trek-brown p-3 pr-8 rounded-lg shadow-2xl shadow-black/50 max-w-xs" data-id="element-114">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-trek-beige/50 hover:text-trek-beige transition-colors" data-id="element-115">
            <X size={14} data-id="element-116" />
          </button>

          <div className="flex-shrink-0 bg-trek-orangeLight/20 p-2 rounded-full" data-id="element-117">
            <Check size={20} className="text-trek-orange" data-id="element-118" />
          </div>

          <div className="flex flex-col" data-id="element-119">
            <p className="text-sm text-trek-beige font-medium leading-tight" data-id="element-120">
              <span className="font-bold text-white" data-id="element-121">{currentName}</span> de{' '}
              {currentCity} acaba de comprar el Pack Trekking Pro
            </p>
            <p className="text-xs text-trek-beige/60 mt-1" data-id="element-122">
              hace {timeAgo} minuto{timeAgo !== 1 ? 's' : ''}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}